import { Base } from "./base";

export class Role extends Base {
  /**
   * @description List Sublocation API function
   * @param {object} filterParams
   * @param {?string} filterParams.location Location ID associated with the sublocation
   * @returns {Promise<Response>}
   */
  list(query) {
    

    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/role?" + queryParam);
    return this._secureFetch(url);


  }

  /**
   * @description Create Sublocation API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/cmms/role");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      }),
    );
  }

  update(uid, payload) {
    const url = this._getFullURL("/cmms/role/" + uid);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      }),
    );
  }

  delete = (uid) => {
    const url = this._getFullURL(`/cmms/role/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      }),
    );
  };
}
